import { Global } from "@emotion/core";
import { commonTokens } from "@smartsheet/design-tokens";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import React from "react";
import { BODY_MARKER_ATTRIBUTE } from "./ThemeMarkerAttribute";
import { createTokenInjector } from "./createTokenInjector";
const BACKGROUND_COLOR_TRANSITION_MILLISECONDS = 200;
const {
  getToken,
  Injector
} = createTokenInjector({
  tokens: commonTokens,
  supportedThemes: ["lodestar-light", "ursa-light", "ursa-dark"],
  namespace: "com"
});

/**
 * @deprecated This utility is being removed in V6+, February 2025, in favor of:
 * - `SDSThemeProvider` from `@smartsheet/lodestar-core`
 * - a global tokens stylesheet from `@smartsheet/design-tokens`
 *
 * Note that the `createTokenInjector()` function will still be available until further notice,
 * enabling teams to continue injecting and accessing their own sets of tokens as needed.
 */

/**
 * @deprecated This utility is being removed in V6+, February 2025, in favor of:
 * - `SDSThemeProvider` from `@smartsheet/lodestar-core`
 * - a global tokens stylesheet from `@smartsheet/design-tokens`
 *
 * Note that the `createTokenInjector()` function will still be available until further notice,
 * enabling teams to continue injecting and accessing their own sets of tokens as needed.
 */
export const CommonTokenInjector = _ref => {
  let {
    themeKey
  } = _ref;
  const [_actualThemeKey, setActualThemeKey] = useState(themeKey);
  const [applyBackgroundColorTransition, setApplyBackgroundColorTransition] = useState(false);

  // Users should get the right theme immediately. This helps w/ tests and the initial paint.
  const firstMountRef = useRef(true);
  if (firstMountRef.current) {
    document.body.setAttribute(BODY_MARKER_ATTRIBUTE, themeKey);
    firstMountRef.current = false;
  }
  useLayoutEffect(() => {
    let animationTimeoutId = 0;
    setApplyBackgroundColorTransition(true);
    // We want to apply the CSS change after a tick to ensure all the React stuff has settled
    // first.
    const rafId = requestAnimationFrame(() => {
      setActualThemeKey(themeKey);
      animationTimeoutId = window.setTimeout(() => {
        setApplyBackgroundColorTransition(false);
      }, BACKGROUND_COLOR_TRANSITION_MILLISECONDS);
      document.body.setAttribute(BODY_MARKER_ATTRIBUTE, themeKey);
    });
    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(animationTimeoutId);
    };
  }, [themeKey]);

  // When this component is unmounted, we should remove the attribute to clean up.
  useEffect(() => () => {
    document.body.removeAttribute(BODY_MARKER_ATTRIBUTE);
  }, [themeKey]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Injector, {
    themeKey: themeKey
  }), /*#__PURE__*/React.createElement(Global, {
    styles: {
      // This should only be added when the themeKey is transitioning or
      // it affects everything else pretty badly.
      "*, *:before, *.after": applyBackgroundColorTransition ? {
        transition: `
                    background-color ${BACKGROUND_COLOR_TRANSITION_MILLISECONDS}ms linear,
                    border-color ${BACKGROUND_COLOR_TRANSITION_MILLISECONDS}ms linear,
                    color ${BACKGROUND_COLOR_TRANSITION_MILLISECONDS}ms linear
                    `
      } : {}
    }
  }));
};
export const color = getToken;
//# sourceMappingURL=CommonTokenInjector.js.map